import { RefObject, useState } from "react";
import { Box, Popover, Typography } from "@material-ui/core";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import type { AppNotification } from "../../models/Notification/notificationTypes";
import { notificationPopoverStyles } from "../../../ThemeProvider";
import NotificationModal from "./NotificationModal";
import NotificationPopoverBody from "./NotificationPopoverBody";

type NotificationPopoverProps = {
  notifications: AppNotification[];
  isLoading: boolean;
  error: Error | null;
  openPopover: boolean;
  anchorEl: RefObject<HTMLElement>;
  onClose: () => void;
};

const NotificationPopover = ({
  notifications,
  isLoading,
  error,
  openPopover,
  anchorEl,
  onClose,
}: NotificationPopoverProps) => {
  const intl = useIntl();
  const classes = notificationPopoverStyles();

  const [selectedNotification, setSelectedNotification] =
    useState<AppNotification>();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => setIsModalOpen(false);

  const handleNotificationClick = (notification: AppNotification) => {
    setSelectedNotification(notification);
    setIsModalOpen(true);
  };

  return (
    <>
      <Popover
        open={openPopover}
        anchorEl={anchorEl.current}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box className={classes.root}>
          <Box className={classes.header}>
            <Typography style={{ color: "white" }} variant="h5">
              {intl.formatMessage({ id: "NOTIFICATIONS" })}
            </Typography>
          </Box>

          <NotificationPopoverBody
            notifications={notifications}
            isLoading={isLoading}
            error={error}
            onNotificationClick={handleNotificationClick}
          />
        </Box>
      </Popover>

      {selectedNotification && (
        <NotificationModal
          open={isModalOpen}
          notifications={[selectedNotification]}
          onClose={handleModalClose}
        />
      )}
    </>
  );
};

export default NotificationPopover;
